import type { FragmentType } from '@/gql/codegen';

import { HeadData } from '@/components/HeadData';
import { StartPage } from '@/routes/_embaUserLayout/-components/StartPage';
import type React from 'react';
import { useState } from 'react';
import { CourseLessonSelfSummarizingPageComponent } from '..';
import type { COURSE_LESSON_SELF_SUMMARIZING_FRAGMENT } from '../index';
import { useAnswerSelfSummarizingQuestionMutation } from './-hooks/useAnswerSelfSummarizingQuestionMutation';

export type CourseLessonSelfSummarizingContainerProps = {
  content: FragmentType<typeof COURSE_LESSON_SELF_SUMMARIZING_FRAGMENT>;
  lessonName: string;
  chapterName: string;
  userAttendanceSlug: string;
  lessonSlug: string;
  onEmbaStartCourseLesson: () => Promise<void>;
  onEmbaCompleteCourseLesson: () => Promise<void>;
  headTitle: string;
};

export const CourseLessonSelfSummarizingContainer = ({
  content,
  lessonName,
  chapterName,
  userAttendanceSlug,
  lessonSlug,
  onEmbaStartCourseLesson,
  onEmbaCompleteCourseLesson,
  headTitle,
}: CourseLessonSelfSummarizingContainerProps) => {
  const [processState, setProcessState] = useState<'start' | 'in progress'>(
    'start',
  );

  const {
    answerSelfSummarizingQuestion,
    answerSelfSummarizingQuestionError,
    answerSelfSummarizingQuestionLoading,
    isAnsweredModalOpen,
    closeAnsweredModal,
  } = useAnswerSelfSummarizingQuestionMutation(userAttendanceSlug, lessonSlug);

  if (answerSelfSummarizingQuestionError) {
    throw answerSelfSummarizingQuestionError;
  }
  const startLesson = () => {
    onEmbaStartCourseLesson();
    setProcessState('in progress');
  };

  return (
    <>
      <HeadData title={headTitle} />
      {processState === 'start' ? (
        <StartPage
          onClick={startLesson}
          chapterName={chapterName}
          lessonName={lessonName}
          lessonType="self_summarizing"
        />
      ) : (
        <CourseLessonSelfSummarizingPageComponent
          content={content}
          lessonName={lessonName}
          chapterName={chapterName}
          onEmbaCompleteCourseLesson={onEmbaCompleteCourseLesson}
          answerSelfSummarizingQuestion={answerSelfSummarizingQuestion}
          answerSelfSummarizingQuestionLoading={
            answerSelfSummarizingQuestionLoading
          }
          isAnsweredModalOpen={isAnsweredModalOpen}
          closeAnsweredModal={closeAnsweredModal}
        />
      )}
    </>
  );
};
